import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './pages/Footer';
import AboutSection from './pages/AboutSection';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Services from './pages/BlogContentArea';
import Ourfleet from './pages/OurFleet';
import Packages from './pages/Packages';
import ContactBoxSection from './pages/ContactBoxSection';
import Enquiry from './pages/Enquiry';
import PortfolioSection from './pages/Gallery';
import Booking from './pages/Booking';
import Punecabservice from './pages/Pune Cab Service';
import Punetaxihire from './pages/Pune Taxi Hire';
import ContactButtons from './components/ContactButtons';
import ScrollToTop from './components/ScrollToTop';
import Puneonlinecabbooking from './pages/Pune Online Cab Booking';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetonashikcabs from './pages/Pune to Nashik Cabs';
import Punetomahabaleshwarcabs from './pages/Pune to Mahabaleshwar Cabs';
import Punetolonavalacabs from './pages/Pune to Lonavala Cabs';
import Punetoshirdicabs from './pages/Pune to Shirdi Cab';
import Punetobhimashankarcabs from './pages/Pune to Bhimashankar Cab';
import Punetokonkandarshancabs from './pages/Pune to Konkan Darshan Cabs';
import Puneoutstationcabs from './pages/Pune Outstation Cabs';
import Ashtavinayakdarshancab from './pages/Ashtavinayak Darshan Cab';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Cabservicenearme from './pages/Cabs Services Near Me';
import Corporatecabserviceinpune from './pages/Corporate Cab Service in Pune';
import Punetomumbaiairportcabs from './pages/Pune to Mumbai Airport Cabs';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta On Rent in Pune';
import Busonrentinpimprichichwad from './pages/Bus On Rent in Pimpri Chinchwad';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Punetosambhajinagartaxi from './pages/Pune to Sambhaji Nagar Taxi';
import Punetoganpatipule from './pages/Pune to Ganpatipule Taxi';
import Punetoharihareshwartaxi from './pages/Pune to Harihareshwar Taxi';
import Punetoalibaugcabs from './pages/Pune to Alibag Cabs';
import Cabserviceinvimannagar from './pages/Cab Service in Viman Nagar';
import Cabserviceinkharadi from './pages/Cab Service in Kharadi';
import Taxiserviceinhinjewadipune from './pages/Taxi Service in Hinjewadi Pune';
import Travelagentsinpune from './pages/Travel Agents in Pune';
import Outstationtaxiservicepune from './pages/Outstation Taxi Service Pune';
import Punetoashtavinayakdarshan from './pages/Pune to Ashtavinayak Darshan Cabs';
import Punetosadeteenshaktipeeth from './pages/Pune to Sade Teen Shakti Peeth Darshan Cabs';
import Punetoakkalkotcabs from './pages/Pune to Akkalkot Cabs';
import Punetotuljapurcabs from './pages/Pune to Tuljapur Cabs';
import Punetopandharpurcabs from './pages/Pune to Pandharpur Cabs';
import Punetogangapurcabs from './pages/Pune to Gangapur Cabs';
import Punetoujjainomkareshwardarshancabs from './pages/Pune to Ujjain Omkareshwar Darshan Cabs';
import Punetojyotilingadarshancabs from './pages/Pune to Jyotirling Darshan Cabs';
import Punetotrimbkeshwarcabs from './pages/Pune to Trimbakeshwar Cabs';
import Punetojejurikhandolatemple from './pages/Pune to Jejuri Khandoba Temple Cabs';
import Cabbookinginpuneforoutstation from './pages/Cab Booking in Pune for Outstation';
import Reliabletaxiserviceinpune from './pages/Reliable Taxi Service in Pune';
import Luxurycarsonrentinpune from './pages/Luxury Cars on Rent in Pune';
import Localsightseeingcabsinpune from './pages/Local Sightseeing Cabs in Pune';
import Onewaytaxifrompune from './pages/One Way Taxi from Pune';
import Roundtripcabpune from './pages/Round Trip Cab Pune';
import Weekendgatwaycabfrom from './pages/Weekend Getaway Cabs from Pune';
import Twentyfourintosevan from './pages/24x7 Cab Service Pune';
import Punetolavasacabservice from './pages/Pune to Lavasa Cab Service';
import Punetomatherancabs from './pages/Pune to Matheran Cabs';
import Punetosataracab from './pages/Pune to Satara Cab';
import Airportpickupanddropinpune from './pages/Airport Pickup and Drop in Pune';
import Cheapestcabserviceinpune from './pages/Cheapest Cab Service in Pune';
import Punelocalcabbooking from './pages/Pune Local Cab Booking';
import Premiumcabserviceinpune from './pages/Premium Cab Service in Pune';
import Punetolgatpuritaxi from './pages/Pune to Igatpuri Taxi';
import Punetobhuleshwartemple from './pages/Pune to Bhuleshwar Temple Cabs';
import Punesightseeing from './pages/Pune Sightseeing Taxi';
import Punedarshancabbooking from './pages/Pune Darshan Cab Booking';
import Eightseatercabonrent from './pages/8-Seater Cab on Rent in Pune';
import Sedantaxihireinpune from './pages/Sedan Taxi Hire in Pune';
import Punetobhandardara from './pages/Pune to Bhandardara Cabs';
import Actaxiserviceinpune from './pages/AC Taxi Service in Pune';
import Punetokolhapurcabs from './pages/Pune to Kolhapur Cabs';
import Cabserviceinwakadpune from './pages/Cab Service in Wakad Pune';
import Punetopuneairporttaxi from './pages/Pune to Pune Airport Taxi';
import Outstationroundroadtripcabs from './pages/Outstation Round Trip Cabs from Pune';
import Localtaxihireinpune from './pages/Local Taxi Hire in Pune';
import Punetosindhurgtaxi from './pages/Pune to Sindhudurg Taxi';
import Punetoalibaugelloracabs from './pages/Pune to Ajanta Ellora Cabs';
import Dailyofficecabserviceinpune from './pages/Daily Office Cab Service in Pune';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Taxiservicechakanpune from './pages/Taxi Service in Chakan Pune';
import Cabserviceinnigdi from './pages/Cab Service in Nigdi Pradhikaran';
import Cabbookingintalegaondabha from './pages/Cab Booking in Talegaon Dabhade';
import Cabserviceinakurdipune from './pages/Cab Service in Akurdi Pune';
import Outstationcabsfrompimprichichwad from './pages/Outstation Cabs from Pimpri Pune';
import Taxifromchikhalitomumbaiairport from './pages/Taxi from Chikhali to Mumbai Airport';
import Cabhireinbhosarimidc from './pages/Cab Hire in Bhosari MIDC Area';
import Pickupdropcabserviceinmoshipune from './pages/Pickup Drop Cab Service in Moshi Pune';
import Carrentalinrevetpune from './pages/Car Rental in Ravet Pune';
import Punetomumbaidarshancabs from './pages/Pune to Mumbai Darshan Cabs';
import Cabserviceinboshari from './pages/Cab Service in Bhosari';
import Cabserviceinmoshi from './pages/Cab Service in Moshi';
import Cabserviceinnigdii from './pages/Cab Service in Nigdi';
import Cabserviceinalandi from './pages/Cab Service in Alandi';
import Cabserviceinrajgurunagar from './pages/Cab Service in Rajgurunagar';
import Cabserviceinkhed from './pages/Cab Service in Khed';
import Cabserviceinkhedcity from './pages/Cab Service in Khed City';
import Cabserviceinbhimashankar from './pages/Cab Service in Bhimashankar';
import Cabaerviceinchakanmidc from './pages/Cab Service in Chakan MIDC';
import Cabserviceinmanchar from './pages/Cab Service in Manchar';
import Cabserviceinnarayangaon from './pages/Cab Service in Narayangaon';
import Cabservicefrompunetogujrat from './pages/Cab Service from Pune to Gujarat';
import Punetojaipurcabs from './pages/Pune to Jaipur Cabs';
import Punetohyderabadcabs from './pages/Pune to Hyderabad Cab';
import Punetorajsthancab from './pages/Pune to Rajasthan Cab';
import Punetoindorecab from './pages/Pune to Indore Cab';
import Punetobenglurucabs from './pages/Pune to Bengaluru Cabs';
import Punetoahmedabadcabservice from './pages/Pune to Ahmedabad Cab Service';
import Punetovadodaracabtaxi from './pages/Pune to Vadodara Cab Taxi';
import Punetoayoshyacabpackage from './pages/Pune to Ayodhya Cab Packages';
import Punetotirupaticabsservice from './pages/Pune to Tirupati Cabs Service';
import Punetochennaicabbooking from './pages/Pune to Chennai Cab Booking';
import Punetosuratcabservice from './pages/Pune to Surat Cab Service';
import Punetokarelacabs from './pages/Pune to Kerala Cabs';
import Punetojammukashmircabs from './pages/Pune to Jammu Kashmir Cabs';
import Punetojaisalamercab from './pages/Pune to Jaisalmer Cab';
import Punetosomnathjyotilingacab from './pages/Pune to Somnath Jyotiling Cabs';
import Punetorameshwaramcab from './pages/Pune to Rameshwaram Cab';
import Punetohublicabservice from './pages/Pune to Hubli Cab Service';
import Punetotelanganacabbooking from './pages/Pune to Telangana Cab Booking';
import Punetojaipurtaxiservice from './pages/Pune to Jaipur Taxi Service';


function App() {



  return (
    <Router>
      <ScrollToTop />
      <Header />
      <ContactButtons />

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Services />} />
        <Route path="/our-fleet" element={<Ourfleet />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<PortfolioSection />} />
        <Route path="/contact-us" element={<ContactBoxSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/pune-cab-service" element={<Punecabservice />} />
      


<Route path="/pune-taxi-hire" element={<Punetaxihire />} />
<Route path="/pune-online-cab-booking" element={<Puneonlinecabbooking />} />
<Route path="/best-cab-service-in-pune" element={<Bestcabserviceinpune />} />
<Route path="/pune-to-mumbai-cabs" element={<Punetomumbaicabs />} />
<Route path="/pune-to-nashik-cabs" element={<Punetonashikcabs />} />
<Route path="/pune-to-mahabaleshwar-cabs" element={<Punetomahabaleshwarcabs />} />
<Route path="/pune-to-lonavala-cabs" element={<Punetolonavalacabs />} />
<Route path="/pune-to-shirdi-cab" element={<Punetoshirdicabs />} />
<Route path="/pune-to-bhimashankar-cab" element={<Punetobhimashankarcabs />} />
<Route path="/pune-to-konkan-darshan-cabs" element={<Punetokonkandarshancabs />} />
<Route path="/pune-outstation-cabs" element={<Puneoutstationcabs />} />
<Route path="/ashtavinayak-darshan-cab" element={<Ashtavinayakdarshancab />} />
<Route path="/pune-to-goa-cabs" element={<Punetogoacabs />} />


<Route path="/cabs-services-near-me" element={<Cabservicenearme />} />
<Route path="/corporate-cab-service-in-pune" element={<Corporatecabserviceinpune />} />
<Route path="/pune-to-mumbai-airport-cabs" element={<Punetomumbaiairportcabs />} />
<Route path="/tempo-traveller-on-rent-in-pune" element={<Tempotravelleronrentinpune />} />
<Route path="/urbania-on-rent-in-pune" element={<Urbaniaonrentinpune />} />
<Route path="/innova-crysta-on-rent-in-pune" element={<Innovacrystaonrentinpune />} />
<Route path="/bus-on-rent-in-pimpri-chinchwad" element={<Busonrentinpimprichichwad />} />
<Route path="/mini-bus-on-rent-in-pune" element={<Minibusonrentinpune />} />
<Route path="/ertiga-on-rent-in-pune" element={<Ertigaonrentinpune />} />
<Route path="/pune-to-sambhaji-nagar-taxi" element={<Punetosambhajinagartaxi />} />
<Route path="/pune-to-ganpatipule-taxi" element={<Punetoganpatipule />} />
<Route path="/pune-to-harihareshwar-taxi" element={<Punetoharihareshwartaxi />} />
<Route path="/pune-to-alibag-cabs" element={<Punetoalibaugcabs />} />
<Route path="/cab-service-in-viman-nagar" element={<Cabserviceinvimannagar />} />
<Route path="/cab-service-in-kharadi" element={<Cabserviceinkharadi />} />
<Route path="/taxi-service-in-hinjewadi-pune" element={<Taxiserviceinhinjewadipune />} />



<Route path="/travel-agents-in-pune" element={<Travelagentsinpune />} />
<Route path="/outstation-taxi-service-pune" element={<Outstationtaxiservicepune />} />
<Route path="/pune-to-ashtavinayak-darshan-cabs" element={<Punetoashtavinayakdarshan />} />
<Route path="/pune-to-sade-teen-shakti-peeth-darshan-cabs" element={<Punetosadeteenshaktipeeth />} />
<Route path="/pune-to-akkalkot-cabs" element={<Punetoakkalkotcabs />} />
<Route path="/pune-to-tuljapur-cabs" element={<Punetotuljapurcabs />} />
<Route path="/pune-to-pandharpur-cabs" element={<Punetopandharpurcabs />} />
<Route path="/pune-to-gangapur-cabs" element={<Punetogangapurcabs />} />
<Route path="/pune-to-ujjain-omkareshwar-darshan-cabs" element={<Punetoujjainomkareshwardarshancabs />} />
<Route path="/pune-to-jyotirling-darshan-cabs" element={<Punetojyotilingadarshancabs />} />
<Route path="/pune-to-trimbakeshwar-cabs" element={<Punetotrimbkeshwarcabs />} />
<Route path="/pune-to-jejuri-khandoba-temple-cabs" element={<Punetojejurikhandolatemple />} />
<Route path="/cab-booking-in-pune-for-outstation" element={<Cabbookinginpuneforoutstation />} />
<Route path="/reliable-taxi-service-in-pune" element={<Reliabletaxiserviceinpune />} />
<Route path="/luxury-cars-on-rent-in-pune" element={<Luxurycarsonrentinpune />} />
<Route path="/local-sightseeing-cabs-in-pune" element={<Localsightseeingcabsinpune />} />
<Route path="/one-way-taxi-from-pune" element={<Onewaytaxifrompune />} />
<Route path="/round-trip-cab-pune" element={<Roundtripcabpune />} />
<Route path="/weekend-getaway-cabs-from-pune" element={<Weekendgatwaycabfrom />} />
<Route path="/24x7-cab-service-pune" element={<Twentyfourintosevan />} />
<Route path="/pune-to-lavasa-cab-service" element={<Punetolavasacabservice />} />
<Route path="/pune-to-matheran-cabs" element={<Punetomatherancabs />} />
<Route path="/pune-to-satara-cab" element={<Punetosataracab />} />
<Route path="/airport-pickup-and-drop-in-pune" element={<Airportpickupanddropinpune />} />
<Route path="/cheapest-cab-service-in-pune" element={<Cheapestcabserviceinpune />} />
<Route path="/pune-local-cab-booking" element={<Punelocalcabbooking />} />


<Route path="/premium-cab-service-in-pune" element={<Premiumcabserviceinpune />} />
<Route path="/pune-to-igatpuri-taxi" element={<Punetolgatpuritaxi />} />
<Route path="/pune-to-bhuleshwar-temple-cabs" element={<Punetobhuleshwartemple />} />
<Route path="/pune-sightseeing-taxi" element={<Punesightseeing />} />
<Route path="/pune-darshan-cab-booking" element={<Punedarshancabbooking />} />
<Route path="/8-seater-cab-on-rent-in-pune" element={<Eightseatercabonrent />} />
<Route path="/sedan-taxi-hire-in-pune" element={<Sedantaxihireinpune />} />
<Route path="/pune-to-bhandardara-cabs" element={<Punetobhandardara />} />
<Route path="/ac-taxi-service-in-pune" element={<Actaxiserviceinpune />} />
<Route path="/pune-to-kolhapur-cabs" element={<Punetokolhapurcabs />} />
<Route path="/cab-service-in-wakad-pune" element={<Cabserviceinwakadpune />} />
<Route path="/pune-to-pune-airport-taxi" element={<Punetopuneairporttaxi />} />
<Route path="/outstation-round-trip-cabs-from-pune" element={<Outstationroundroadtripcabs />} />
<Route path="/local-taxi-hire-in-pune" element={<Localtaxihireinpune />} />
<Route path="/pune-to-sindhudurg-taxi" element={<Punetosindhurgtaxi />} />
<Route path="/pune-to-ajanta-ellora-cabs" element={<Punetoalibaugelloracabs />} />
<Route path="/daily-office-cab-service-in-pune" element={<Dailyofficecabserviceinpune />} />
<Route path="/cab-service-in-pimpri-chinchwad" element={<Cabserviceinpimprichichwad />} />
<Route path="/taxi-service-in-chakan-pune" element={<Taxiservicechakanpune />} />
<Route path="/cab-service-in-nigdi-pradhikaran" element={<Cabserviceinnigdi />} />
<Route path="/cab-booking-in-talegaon-dabhade" element={<Cabbookingintalegaondabha />} />
<Route path="/cab-service-in-akurdi-pune" element={<Cabserviceinakurdipune />} />
<Route path="/outstation-cabs-from-pimpri-pune" element={<Outstationcabsfrompimprichichwad />} />
<Route path="/taxi-from-chikhali-to-mumbai-airport" element={<Taxifromchikhalitomumbaiairport />} />
<Route path="/cab-hire-in-bhosari-midc-area" element={<Cabhireinbhosarimidc />} />
<Route path="/pickup-drop-cab-service-in-moshi-pune" element={<Pickupdropcabserviceinmoshipune />} />
<Route path="/car-rental-in-ravet-pune" element={<Carrentalinrevetpune />} />
<Route path="/pune-to-mumbai-darshan-cabs" element={<Punetomumbaidarshancabs />} />



<Route path="/cab-service-in-bhosari" element={<Cabserviceinboshari />} />
<Route path="/cab-service-in-moshi" element={<Cabserviceinmoshi />} />
<Route path="/cab-service-in-nigdi" element={<Cabserviceinnigdii />} />
<Route path="/cab-service-in-alandi" element={<Cabserviceinalandi />} />
<Route path="/cab-service-in-rajgurunagar" element={<Cabserviceinrajgurunagar />} />
<Route path="/cab-service-in-khed" element={<Cabserviceinkhed />} />
<Route path="/cab-service-in-khed-city" element={<Cabserviceinkhedcity />} />
<Route path="/cab-service-in-bhimashankar" element={<Cabserviceinbhimashankar />} />
<Route path="/cab-service-in-chakan-midc" element={<Cabaerviceinchakanmidc />} />
<Route path="/cab-service-in-manchar" element={<Cabserviceinmanchar />} />
<Route path="/cab-service-in-narayangaon" element={<Cabserviceinnarayangaon />} />



<Route path="/pune-to-gujarat-cabs" element={<Cabservicefrompunetogujrat />} />
<Route path="/pune-to-jaipur-cabs" element={<Punetojaipurcabs />} />
<Route path="/pune-to-hyderabad-cab" element={<Punetohyderabadcabs />} />
<Route path="/pune-to-rajasthan-cab" element={<Punetorajsthancab />} />
<Route path="/pune-to-indore-cab" element={<Punetoindorecab />} />
<Route path="/pune-to-bengaluru-cabs" element={<Punetobenglurucabs />} />
<Route path="/pune-to-ahmedabad-cab-service" element={<Punetoahmedabadcabservice />} />
<Route path="/pune-to-vadodara-cab-taxi" element={<Punetovadodaracabtaxi />} />
<Route path="/pune-to-ayodhya-cab-packages" element={<Punetoayoshyacabpackage />} />
<Route path="/pune-to-tirupati-cabs-service" element={<Punetotirupaticabsservice />} />
<Route path="/pune-to-chennai-cab-booking" element={<Punetochennaicabbooking />} />
<Route path="/pune-to-surat-cab-service" element={<Punetosuratcabservice />} />
<Route path="/pune-to-kerala-cabs" element={<Punetokarelacabs />} />
<Route path="/pune-to-jammu-kashmir-cabs" element={<Punetojammukashmircabs />} />
<Route path="/pune-to-jaisalmer-cab" element={<Punetojaisalamercab />} />
<Route path="/pune-to-somnath-jyotiling-cabs" element={<Punetosomnathjyotilingacab />} />
<Route path="/pune-to-rameshwaram-cab" element={<Punetorameshwaramcab />} />
<Route path="/pune-to-hubli-cab-service" element={<Punetohublicabservice />} />
<Route path="/pune-to-telangana-cab-booking" element={<Punetotelanganacabbooking />} />
<Route path="/pune-to-jaipur-taxi-service" element={<Punetojaipurtaxiservice />} />



      </Routes>
      <Footer />
    </Router>


  );
}

export default App;
